export default {
  water2nd: '수이국',
  wood3rd: '목삼국',
  metal4th: '금사국',
  earth5th: '토오국',
  fire6th: '화육국',
} as const;
